<div class="contact-bg">
  <h5 class="iq-tw-7 iq-mb-10 iq-font-{{ addressColor }}">{{ addressTitle }}</h5>
  <ul [ngClass]="addressClass">
    <li *ngFor="let option of addressContent">
      <i *ngIf="option.icon" class="{{ option.iconClass }}"></i>
      <p>{{ option.text }}</p>
    </li>
  </ul>
</div>
